import { useEffect } from "react";

import PlayerList from "./PlayerList";
import ReadyButton from "./ReadyButton";
import LogoutButton from "./LogoutButton";
import config from "./appconf";
import { SessionInfo } from "./common/Info";
import { useAppDispatch, setSession } from "./store";
import { connectToSSE } from "./EventSource";

function LobbyPage() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    fetch(`${config.baseUrl}/api/v1/status`, {
      mode: "cors",
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 200) {
          res.json().then((sessionInfo: SessionInfo) => {
            dispatch(setSession(sessionInfo));
            connectToSSE();
          });
        }
      })
      .catch((error) => {
        console.log("Ran into an error trying to get status data");
        console.log(error);
      });
  }, []);
  return (
    <div className="centerContainer height100">
      <div>
        <h1>Quixx Pre-game Lobby</h1>
        <PlayerList />
        <ReadyButton />
        <LogoutButton />
      </div>
    </div>
  );
}

export default LobbyPage;
